import limesharp from "../images/logos/limesharp.svg";
import generazia from "../images/logos/generazia.svg";

const experience = [
  {
    company: {
      name: "Limesharp Internet Ltd.",
      location: "London, UK",
      role: "Front End Developer",
      period: "August 2022 - September 2023 (~1 year)",
      siteUrl: "https://limesharp.net/",
      logo: {
        light: limesharp,
      },
    },
    about: {
      paragraph:
        "I would consider this as the major leap forward in experience, knowledge, and expertise in my career, as Limesharp is an eCommerce agency that gave me the opportunity to work on a large variety of tasks in different environments, collectively having the necessary impact on me to improve and develop on different key aspects to continuously grow not only as a front end developer but also as a person and individual in a more team-focused environment.",
      duties: [
        "Developed, maintained, and shipped production code for client websites primarily using HTML, CSS, SASS, Tailwind, JavaScript, and Vue.js",
        "Performed quality assurance tests on various sites to ensure cross-browser compatibility and mobile responsiveness",
        "Clients included <a href='https://www.meandem.com/' target='_blank' rel='noreferrer'>ME+EM</a>, <a href='https://www.broraonline.com/' target='_blank' rel='noreferrer'>Brora</a> , <a href='https://www.joloves.com/' target='_blank' rel='noreferrer'>Jo Loves</a>, <a href='https://www.gfsmith.com/' target='_blank' rel='noreferrer'>GF Smith</a> , and more",
      ],
    },
    recommendations: [
      {
        person: "Ed Bull",
        role: "CEO of Limesharp",
        text: "Edin has proven himself to be an incredibly motivated, hard working and passionate developer. He is also great fun to work with on a day to day basis.",
        linkedIn: "https://www.linkedin.com/in/ed-bull-limesharp/",
      },
      {
        person: "Nahuel Sanchez",
        role: "HOD at Limesharp",
        text: "Edin was one of the best hirings that I ever did, always ready to be faced with more challenges, more complex tasks and bigger integrations.",
        linkedIn: "https://www.linkedin.com/in/nahuelsanchez/",
      },
    ],
  },
  {
    company: {
      name: "Generazia d.o.o.",
      location: "Kakanj, BA",
      role: "Front End Developer",
      period: "January 2021 - May 2022 (~1.5 years)",
      siteUrl: "https://generazia.ba/",
      logo: {
        light: generazia,
      },
    },
    about: {
      paragraph:
        "I decided to join this company with the aim of expanding my understanding of web development, mainly focusing on the front-end aspect. My role involved developing front-end components, which were both clear-cut and demanding. I found quite the pleasure and satisfaction in carrying out this task. I eagerly anticipated it every single day. Eventually, I left the company feeling fulfilled and driven to pursue a position that would propel my career forward within this field.",
      duties: [
        "Built components and developed code that could be easily reused in parts of the website.",
        "I utilized my expertise in HTML to structure the content of web pages, while also making it semantically appealing with accessibility in mind.",
        "I used CSS to create cohesive layouts, and firmly styled components, incorporating responsiveness across devices.",
        "My knowledge of JavaScript allowed me to incorporate features, like form validation, animations and interactive elements to enhance user experience.",
      ],
    },
    recommendations: [
      {
        person: "Amer Sikira",
        role: "CEO of Generazia",
        text: "Edin, a dedicated developer, excelled in grasping concepts, working independently, and meeting deadlines. His energy positively impacted the small tech company. Due to limited advancement opportunities and salary constraints, he decided to seek new opportunities, leaving a lasting, exceptional impression.",
        linkedIn: "https://www.linkedin.com/in/amer-sikira/",
      },
    ],
  },
];

export { experience };
